import React, { useState, createRef, Fragment } from 'react'
import classNames from 'classnames'
import { Check, Trash, ArrowCounterClockwise } from "@phosphor-icons/react";

export default function EditTableCell({
    cell,
    readOnly,
    index
}) {

    const [editing, setEditing] = useState(false);
    const formRef = createRef();

    const flex = cell.flex ? Number(cell.flex) : 1;

    const CellClasses = classNames({
        "relative table-cell border-b border-r border-line last:border-r-0 h-full": true,
        "bg-extralightprimary": cell.hl,
        "flex-1": flex === 1,
        "flex-2": flex === 2,
        "flex-3": flex === 3,
        "flex-4": flex === 4,
        "flex-5": flex === 5,
    })

    const InputClasses = classNames({
        'w-full bg-transparent outline-none px-2 min-h-35 border focus:border-primary hover:border-black focus:bg-white text-sm focus:ring focus:ring-primary focus:ring-opacity-20': true,
        'text-center': cell.align === 'center',
        'text-right': cell.align === 'right',
        'border-transparent': !editing,
        'border-black': editing,
    })

    const TextClasses = classNames({
        "w-full min-h-35 flex items-center outline-none px-2 py-1 text-sm": true,
        "cursor-pointer": cell.action,
        "text-center": cell.align === "center",
        "text-right justify-end": cell.align === "right",
        "font-medium": cell.hl,
        [`text-${cell.color}`]: cell.color,
    })

    // SUBMIT
    function onSubmitHandler(e) {
        e.preventDefault();
        const value = e.target[0].value;
        if (cell.onSubmit) {
            cell.onSubmit(value);
        }
        return setEditing(false);
    }

    // CHANGE
    function onChangeHandler(e) {
        if (typeof cell.onChange === "function") {
            return cell.onChange(e.target.value);
        }
        return;
    }

    // RESET
    function onResetHandler() {
        formRef.current.reset()
        return setEditing(false);
    }

    function onWheelHandler(e) {
        e.preventDefault();
        e.target.blur();
    }

    return (
        <div className={CellClasses} key={`row-${index}-cell-${index}`}>
            {cell.type === 'input' &&
                <Fragment>
                    {!editing ?
                        <div className={TextClasses} onClick={!readOnly ? (() => setEditing(true)) : undefined}>{cell.value}</div>
                    :
                        <div className='relative'>
                            <form onSubmit={onSubmitHandler} ref={formRef}>
                                <input
                                    type={cell.inputType || 'text'}
                                    step="0.01"
                                    className={InputClasses}
                                    defaultValue={cell.value}
                                    name={cell.name}
                                    onChange={onChangeHandler}
                                    onBlur={cell.onBlur}
                                    onWheel={onWheelHandler}
                                />
                                {editing &&
                                    <div className='absolute z-1 top-35 right-0 pt-px flex'>
                                            <button className='h-8 w-8 md:h-6 md:w-6 flex items-center justify-center bg-gray cursor-pointer rounded-md md:rounded-sm hover:bg-black' onClick={onResetHandler}>
                                                <ArrowCounterClockwise className='w-4 h-4 fill-white' />
                                            </button>
                                        <button type="submit" className='h-8 w-8 md:h-6 md:w-6 flex items-center justify-center bg-primary cursor-pointer rounded-md md:rounded-sm ml-px hover:bg-black'>
                                            <Check className='w-4 h-4 fill-white' />
                                        </button>

                                        {(cell.value && cell.onDelete) &&
                                            <button className='h-8 w-8 md:h-6 md:w-6 flex items-center justify-center bg-red cursor-pointer rounded-md md:rounded-sm ml-px hover:bg-black' onClick={() => cell.onDelete(cell.name, cell.value)}>
                                                <Trash className='w-4 h-4 fill-white' />
                                            </button>
                                        }
                                    </div>
                                }
                            </form>
                        </div>
                    }
                </Fragment>
            }

            {cell.type === 'text' &&
                <div
                    className={TextClasses}
                    onClick={cell.action ? cell.action : undefined}
                >
                    {cell.text}
                </div>
            }

        </div>
    )
}
